import { WebActionNames } from "../constants/webActionNames";
import { Feedback } from "../store/feedback";
import { WebControllers } from "../constants/webControllers";
import { post } from "../common/dataFetch";

export const createAsync = (feedback: Omit<Feedback, "id">) => post<number, Omit<Feedback, "id">>(WebControllers.Feedback, WebActionNames.CreateAsync, feedback);

export const updateAsync = (feedback: Feedback) => post(WebControllers.Feedback, WebActionNames.UpdateAsync, feedback);